import { T } from '../../i18n';
import { getSpanLineColor } from './map.line/map.line';
import type { PoleAccuracy } from './map.point/map.point';

/**
 * A legend swatch, described independently of how it is rendered. The on-screen `MapModeLegend`
 * (Mithril/CSS) and the print legend (pdfMake) both consume the same descriptor list so the two
 * can never drift in content, color, or order.
 */
export type LegendSwatch =
	| { kind: 'line'; color: string }
	| { kind: 'point'; accuracy: PoleAccuracy; selected?: boolean }
	| { kind: 'collectionLabel' };

export interface LegendItem {
	swatch: LegendSwatch;
	text: T;
}

export const LEGEND_ITEMS: LegendItem[] = [
	{ swatch: { kind: 'line', color: getSpanLineColor('dropspan') }, text: T.MAPMODE_LEGEND_DROPSPAN },
	{ swatch: { kind: 'line', color: getSpanLineColor('anchor') }, text: T.MAPMODE_LEGEND_ANCHOR },
	{ swatch: { kind: 'line', color: getSpanLineColor('span') }, text: T.MAPMODE_LEGEND_SPAN },
	{ swatch: { kind: 'line', color: getSpanLineColor('unknown') }, text: T.MAPMODE_LEGEND_UNKNOWN },
	{ swatch: { kind: 'collectionLabel' }, text: T.MAPMODE_LEGEND_COLLECTION_LABEL },
	{ swatch: { kind: 'point', accuracy: 'rtk_fixed', selected: true }, text: T.MAPMODE_LEGEND_SELECTED_COLLECTION },
	{ swatch: { kind: 'point', accuracy: 'rtk_fixed' }, text: T.MAPMODE_LEGEND_LOCATION_RTK_FIXED },
	{ swatch: { kind: 'point', accuracy: 'edited' }, text: T.MAPMODE_LEGEND_LOCATION_REVIEWED },
	{ swatch: { kind: 'point', accuracy: 'rtk_float' }, text: T.MAPMODE_LEGEND_LOCATION_RTK_FLOAT },
	{ swatch: { kind: 'point', accuracy: 'low' }, text: T.MAPMODE_LEGEND_LOCATION_LOW_ACCURACY },
];
